import { datadogRum } from '@datadog/browser-rum';

interface RumUserIdentity {
  // Required so this binds the non-deprecated `setUser` overload; the Frontegg
  // user id is always a non-optional string at the call site.
  id: string;
  email?: string;
}

/**
 * Identify the current user in RUM so every event is faceted by user.
 * We send the opaque Frontegg `id` (Datadog's canonical, non-deprecated user
 * key) plus `email` — consistent with Sentry (`sendDefaultPii: true`) and
 * Userpilot. `name` is intentionally omitted (email is unique and sufficient).
 * Strict privacy applies to portfolio/financial data, not user identity.
 */
export function setRumUser(user: RumUserIdentity | undefined): void {
  if (!user) {
    return;
  }
  datadogRum.setUser({ id: user.id, email: user.email });
}

/** Facet every RUM event by org/fund. */
export function setRumOrgContext(org: string | undefined): void {
  if (!org) {
    return;
  }
  datadogRum.setGlobalContextProperty('org', org);
}
